export const download = (fileName, buffer) => {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(new Blob([buffer]));
  link.download = fileName;
  link.click();
  link.remove();
};
